module.exports = __webpack_public_path__ + "static/media/van_purple.18e49d31.svg";